import { useTranslation } from "react-i18next";
import { mainheader, mainheader2 } from "assets/images";

interface MainTitleProps {
  title?: string;
}

const MainTitle = ({ title }: MainTitleProps) => {
  const { i18n } = useTranslation();
  return (
    <section
      data-aos="fade-down"
      data-aos-duration="200"
      className={` w-full h-[330px] 
        
        bg-cover  flex items-center justify-center lg:justify-start shadow-lg relative`}
    >
      {i18n.language === "en" ? (
        <img
          className="w-full h-full absolute top-0 left-0"
          src={mainheader}
          alt=""
        />
      ) : (
        <img
          className="w-full h-full absolute top-0 left-0"
          src={mainheader2}
          alt=""
        />
      )}
      <p
        className={`mainContainer w-full h-full pt-[150px] font-${
          i18n.language === "en"
            ? "Poppins pl-[20px] lg:pl-0"
            : "Almarai pr-[20px] lg:pr-0"
        } font-[700] text-[20px] lg:text-[32px] text-second_color`}
      >
        {title}
      </p>
    </section>
  );
};

export default MainTitle;
